import { GraphQLErrorEnvelope } from "./graphql-error-envelope";

export function extractGraphQLErrorReasonList(error: unknown): string[] {
  if (!error || typeof error !== "object") {
    return [];
  }

  const errorList = (error as GraphQLErrorEnvelope).response?.errors;
  if (!Array.isArray(errorList)) {
    return [];
  }

  return errorList
    .map((entry) => entry?.extensions?.originalError?.reason)
    .filter((reason): reason is string => typeof reason === "string");
}
